import React from 'react'
import { IconSolidStar } from '@notino/react-styleguide'
import { useIntl } from 'react-intl'

// types
import { Ratings as RatingsData } from '../../../../types/types'

// components
import VisuallyHidden from '../../../../atoms/VisuallyHidden/VisuallyHidden'

// styles
import * as SC from './SalonRatingsStyles'

type SalonRatingsProps = {
	ratingsData: RatingsData
}

const SalonRatings = (props: SalonRatingsProps) => {
	const { ratingsData: ratings } = props
	const intl = useIntl()

	const ratingsList = [
		{
			rating: 5,
			count: ratings.groupedRatings.FIVE,
			percentage: (ratings.groupedRatings.FIVE / ratings.ratesCount) * 100 || 0
		},
		{
			rating: 4,
			count: ratings.groupedRatings.FOUR,
			percentage: (ratings.groupedRatings.FOUR / ratings.ratesCount) * 100 || 0
		},
		{
			rating: 3,
			count: ratings.groupedRatings.THREE,
			percentage: (ratings.groupedRatings.THREE / ratings.ratesCount) * 100 || 0
		},
		{
			rating: 2,
			count: ratings.groupedRatings.TWO,
			percentage: (ratings.groupedRatings.TWO / ratings.ratesCount) * 100 || 0
		},
		{
			rating: 1,
			count: ratings.groupedRatings.ONE,
			percentage: (ratings.groupedRatings.ONE / ratings.ratesCount) * 100 || 0
		}
	]

	const getStarsAriaLabel = (starCount: number) =>
		intl.formatMessage(
			{
				id: '{starCount, plural, one {# star} other {# stars}}',
				defaultMessage: '{starCount, plural, one {# star} other {# stars}}'
			},
			{ starCount }
		)

	const getReviewsDistributionAriaLabel = (reviewCount: number, percentage: number) =>
		intl.formatMessage(
			{
				id: '{reviewCount, plural, one {# review} other {# reviews}}, {percentage}% of all reviews',
				defaultMessage: '{reviewCount, plural, one {# review} other {# reviews}}, {percentage}% of all reviews'
			},
			{ reviewCount, percentage: Math.round(percentage) }
		)

	return (
		<SC.RatingsList>
			{ratingsList.map((ratingObj) => {
				return (
					<SC.RatingWrapper key={ratingObj.rating}>
						<SC.RatingValue>
							<SC.RatingValueText aria-hidden={'true'}>{ratingObj.rating}</SC.RatingValueText>
							<span aria-hidden={'true'}>
								<IconSolidStar color={'text.primary'} width={'1rem'} height={'1rem'} />
							</span>
							<VisuallyHidden>{getStarsAriaLabel(ratingObj.rating)}</VisuallyHidden>
						</SC.RatingValue>
						<SC.ProgressLineWithCount>
							<SC.ProgressBarContainer aria-hidden={'true'}>
								<SC.Progress $progress={ratingObj.percentage} />
							</SC.ProgressBarContainer>
							<SC.Count aria-hidden={'true'}>{ratingObj.count}</SC.Count>
							<VisuallyHidden>{getReviewsDistributionAriaLabel(ratingObj.count, ratingObj.percentage)}</VisuallyHidden>
						</SC.ProgressLineWithCount>
					</SC.RatingWrapper>
				)
			})}
		</SC.RatingsList>
	)
}

export default SalonRatings
